import FunnerInternalGuard from 'utils/route-guard/FunnerInternalGuard';
import { GuardProps } from 'types';

const OPS_CONSOLE_COMPANY_ID = (
  import.meta.env.VITE_APP_FUNNER_COMPANY_ID ?? '07b9f2b0-dba8-486b-89bd-4d20246c7798'
).toLowerCase();

export function isOpsConsoleCompany(companyId: string | null | undefined): boolean {
  return Boolean(companyId && companyId.toLowerCase() === OPS_CONSOLE_COMPANY_ID);
}

// ==============================|| OPS CONSOLE GUARD ||============================== //

/**
 * Restricts `/ops-console` to Funner internal company only.
 * Same company-id check as other Funner-only UI (`VITE_APP_FUNNER_COMPANY_ID`).
 */
export default function OpsConsoleGuard({ children }: GuardProps) {
  return <FunnerInternalGuard>{children}</FunnerInternalGuard>;
}
